// SectionHeader.jsx
// Consistent section header for the "My Experiments" panels: leading icon +
// title + count badge, an optional supporting subtitle, and a right-aligned
// action slot (the primary CTA). Keeps both sections visually symmetrical.
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import {
  FONT,
  WEIGHT,
  INK,
  INK_SECONDARY,
  INK_MUTED,
  SURFACE_MUTED,
  HAIRLINE,
} from "../../../../theme/tokens";

export default function SectionHeader({
  icon: Icon,
  title,
  count,
  subtitle,
  action,
}) {
  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "flex-start",
        justifyContent: "space-between",
        gap: 2,
        flexWrap: "wrap",
        mb: 2.5,
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: 0.25,
          minWidth: 0,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          {Icon && <Icon sx={{ fontSize: 20, color: INK_SECONDARY }} />}
          <Typography
            component="h2"
            sx={{ fontSize: FONT.xl, fontWeight: WEIGHT.semibold, color: INK }}
          >
            {title}
          </Typography>
          {count != null && (
            <Box
              component="span"
              sx={{
                px: 0.875,
                py: 0.125,
                borderRadius: "999px",
                bgcolor: SURFACE_MUTED,
                border: `1px solid ${HAIRLINE}`,
                color: INK_SECONDARY,
                fontSize: FONT.xs,
                fontWeight: WEIGHT.semibold,
                lineHeight: 1.6,
              }}
            >
              {count}
            </Box>
          )}
        </Box>
        {subtitle && (
          <Typography sx={{ fontSize: FONT.sm, color: INK_MUTED }}>
            {subtitle}
          </Typography>
        )}
      </Box>

      {action && <Box sx={{ flexShrink: 0 }}>{action}</Box>}
    </Box>
  );
}

SectionHeader.propTypes = {
  icon: PropTypes.elementType,
  title: PropTypes.string.isRequired,
  count: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  subtitle: PropTypes.string,
  action: PropTypes.node,
};
